module.exports = __webpack_public_path__ + "img/brillante_4.4fc29c49.svg";